<template>
	<li class="splitter"></li>
</template>
<script>
	export default {
		data() {
			return {

			}
		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {

		},
	}
</script>
<style></style>
